import useViewPage from './useViewPage'

export default useViewPage
